module.exports = __webpack_public_path__ + "static/moonamar-hladno-cijedeno-djevicansko-laneno-ulje-b119d2ffcb5de6a94ad6625c8784af3c.png";